import React, { useContext } from "react";
import { makeStyles, useTheme } from "@material-ui/core/styles";

import {
  IconButton, SvgIcon, Tooltip, Grid
} from "@material-ui/core";
import KeyboardBackspaceIcon from '@material-ui/icons/KeyboardBackspace';

import { PageContext } from "../../../contexts/PageContext";


export default function FirstPaymentDateComputationHelper({ creditFunctions }) {
  const pageContext = useContext(PageContext);


  return (
    <Grid container alignItems="center">
      <Grid item>
        <KeyboardBackspaceIcon size="small" color="primary" />
      </Grid>
      <Grid item>
        <Tooltip title="Datum berechnen">
          <IconButton
            color="secondary"
            onClick={() => {
              const months_tilgungsfrei = creditFunctions.getFirstValueByMetaKey("finanzierungslaufzeit_davon_tilgungsfrei");
              let rueckzahlung_ratenfaelligkeit = creditFunctions.getFirstValueByMetaKey("rueckzahlung_ratenfaelligkeit");
              if (!rueckzahlung_ratenfaelligkeit) {
                rueckzahlung_ratenfaelligkeit = 1;
              }
              const today = new Date();
              // übernächstes Monat am ausgewählten Tag (1. / 5. / 15.) + tilgungsfreie Monate
              creditFunctions.setValuesByMetaKey(
                "rueckzahlung_datum_der_ersten_pauschalrate",
                new Date(today.getFullYear(), today.getMonth() + 2 + months_tilgungsfrei, rueckzahlung_ratenfaelligkeit)
              )
              pageContext.setInfoMessage("Die erste Rate wurde auf übernächstes Monat plus der tilgungsfreien Zeit gesetzt.");
            }}
          >
            <SvgIcon>
              <path fill="currentColor" d="M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3M19 19H5V5H19V19M6.2 7.7H11.2V9.2H6.2V7.7M13 15.8H18V17.3H13V15.8M13 13.2H18V14.7H13V13.2M8 18H9.5V16H11.5V14.5H9.5V12.5H8V14.5H6V16H8V18M14.1 10.9L15.5 9.5L16.9 10.9L18 9.9L16.6 8.5L18 7.1L16.9 6L15.5 7.4L14.1 6L13 7.1L14.4 8.5L13 9.9L14.1 10.9Z" />
            </SvgIcon>
          </IconButton>
        </Tooltip>
      </Grid>
    </Grid>
  );
}
